import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';
import {gallery} from '/theme/color/secondary.color';
import {createWebEnhancedStyles} from '/util/webStyles.util';

export const TAB_BAR_HEIGH = 58;

export const styles = createWebEnhancedStyles({
  tabBarIndicatorStyle: {
    backgroundColor: denim,
    zIndex: 100,
  },
  tabBarIndicatorContainerStyle: {
    backgroundColor: gallery,
    height: 2,
    marginTop: indent * 2.3,
  },
  tabBar: {
    shadowOpacity: 0,
    elevation: 0,
    overflowX: 'auto',
  },
  sceneContainer: {
    flex: 1,
    minHeight: 0,
    backgroundColor: 'white',
    paddingTop: TAB_BAR_HEIGH,
  },
});
